import axios from 'axios';
import {actions as A} from '../constants/actions';
import {api} from '../constants/api';
import {setTokens} from './setTokens';
import {setUserId, setUserTypeId} from './setUser';
import {setFirmLogo} from './setFirmLogo';
import {errors as E} from 'common/constants/errors';
import {userTypeIds as U} from '../../../common/constants/userTypeIds';

export const login = ({tokens, email}) => async dispatch => {
  dispatch({
    type: A.LOGIN,
  });

  const {expire, uid, ...rest} = tokens;
  const data = {
    userID: email,
    expireTime: expire,
    ...rest
  };

  const response = await axios.post(api.LOGIN, data);
  const {errorCode, body} = response.data;
  if (errorCode < 0) throw new Error(E.SERVER_ERROR);

  const {
    firmLogoUrl,
    userID,
    userTypeID,
    allowInspectionsShare,
    adminPermissionsLevel,
    firmInspectionsAccess
  } = body;

  await setFirmLogo(firmLogoUrl)(dispatch);
  await setUserId(userID)(dispatch);
  await setUserTypeId(userTypeID)(dispatch);
  await dispatch({
    type: A.SET_USER_PROPS,
    payload: {
      userTypeID,
      userId: userID,
      firmLogo: firmLogoUrl,
      allowInspectionsShare: Boolean(allowInspectionsShare),
      adminPermissionsLevel: (userTypeID !== U.REGULAR && typeof adminPermissionsLevel !== 'number')
        ? 0
        : adminPermissionsLevel,
      firmInspectionsAccess: Boolean(firmInspectionsAccess)
    }
  });
  await setTokens({
    ...tokens,
    receivedAt: new Date(response.data.header.response_server_time)
  })(dispatch);
};
